import { render, staticRenderFns } from "./shopBalance.vue?vue&type=template&id=46ecf120&scoped=true&"
import script from "./shopBalance.vue?vue&type=script&lang=js&"
export * from "./shopBalance.vue?vue&type=script&lang=js&"
import style0 from "./shopBalance.vue?vue&type=style&index=0&id=46ecf120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ecf120",
  null
  
)

export default component.exports